import SimpleFormPage from "../common/SimpleFormPage";
import DpiProductFields from "./DpiProductFields";

export default function NewDpiProduct() {
  return (
    <SimpleFormPage title="Nuovo prodotto DPI">
      <DpiProductFields />
    </SimpleFormPage>
  );
}
